import React from 'react';
import './UIMultiInputWithLabel.scss';

// Props for a single input field
export interface UIMultiInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

// Props for the entire component
export interface UIMultiInputWithLabelProps {
  label: string;
  labelWidth?: number;
  inputs: UIMultiInputProps[];
  inputWidths?: number[];
  className?: string;
}

const UIMultiInputWithLabel: React.FC<UIMultiInputWithLabelProps> = ({
                                                                       label,
                                                                       labelWidth = 25, // Default label width to match UIInputWithLabel
                                                                       inputs = [],
                                                                       inputWidths = [],
                                                                       className = '',
                                                                     }) => {
  const labelStyle = {
    flex: `0 0 ${labelWidth}%`,
  };

  const renderLabel = () => {
    const parts = label.split('*');
    return parts.map((part, index) => (
      <React.Fragment key={index}>
        {part}
        {index < parts.length - 1 && <span className="UIMultiInputWithLabel__asterisk">*</span>}
      </React.Fragment>
    ));
  };

  return (
    <div className={`UIMultiInputWithLabel ${className}`}>
      <label className="UIMultiInputWithLabel__label" style={labelStyle}>
        {renderLabel()}
      </label>
      <div className="UIMultiInputWithLabel__inputs">
        {inputs.map((inputProps, index) => {
          const inputStyle: React.CSSProperties = {};
          // Use the width value as a flex-grow factor.
          // This correctly distributes space while accounting for gaps.
          if (inputWidths[index]) {
            inputStyle.flex = `${inputWidths[index]}`;
          } else {
            // If no widths are provided, distribute equally
            inputStyle.flex = '1';
          }

          return (
            <input
              key={index}
              {...inputProps}
              className="UIMultiInputWithLabel__input"
              style={inputStyle}
            />
          );
        })}
      </div>
    </div>
  );
};

export default UIMultiInputWithLabel;